import React, {useState, useEffect} from 'react';
import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { makeStyles } from '@material-ui/core/styles';
import {
    AppBar,
    Toolbar,
    Typography,
    Container,
    Paper,
} from '@material-ui/core';

import { Assets } from 'enums';
import { Alert, Modal, Button, Spinner, Table, } from 'react-bootstrap';
import { PageStatus } from 'enums';
import { Show } from 'Layout';
import * as _ from "lodash";
import ShowDataAccording2PageSize from '../ShowEntries/ShowEntries';
import PaginationNumbering from '../ShowEntries/Pagination';
import ReactQuill from 'react-quill';
import { FaqAPI } from './FaqApi';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useSelector } from "react-redux";

// const useStyles = makeStyles((theme) => ({
//     root: {
//         flexGrow: 1,
//     },
//     appBar: {
//         marginBottom: theme.spacing(3),
//     },
//     content: {
//         padding: theme.spacing(3),
//         textAlign: 'left',
//     },
//     paper: {
//         padding: theme.spacing(2),
//         display: 'flex',
//         overflow: 'auto',
//         flexDirection: 'column',
//         alignItems: 'center',
//     },
//     logo: {
//         width: '100%',
//         maxWidth: '400px', // Adjust the maximum width as needed
//     },
// }));
const faqData = [
    {
      question: "मैं सर्वे कैसे प्राप्त कर सकता हूं ?",
      answer: "यदि कोई सर्वे आपकी प्रोफ़ाइल से मेल खाता है, तो आपको अपने पंजीकृत ई-मेल आईडी पर या एसएमएस या व्हाट्सएप मैसेजिंग के माध्यम से एक लिंक प्राप्त होगा, जो आपको सर्वे में भाग लेने के लिए पुनः निर्देशित करेगा। हम आपसे अनुरोध करते हैं कि सर्वे में भाग लेने और i-प्वाइंट अर्जित करने के लिए इन तीनों माध्यमों की नियमित रूप से जांच करें। आपका प्रोफ़ाइल सर्वे जितना अधिक अद्यतन होगा, आपको सर्वे में भाग लेने और i-प्वाइंट अर्जित करने के लिए आमंत्रित किए जाने की संभावना उतनी ही अधिक होगी।"
    }, 
    {
        question : "मुझे कितनी बार सर्वे प्राप्त होगा?", 
        answer : "आपके द्वारा प्राप्त सर्वेों की संख्या किसी भी समय चलाए जा रहे सर्वेों की संख्या पर निर्भर करती है। कभी-कभी एक साथ बहुत सारे हो सकते हैं, और कभी-कभी केवल कुछ ही हो सकते हैं। आपके द्वारा दर्ज की गई प्रोफ़ाइल जानकारी यह सुनिश्चित करने के लिए बहुत महत्वपूर्ण है कि आपका मिलान किया जा सके जितना संभव हो उतने सर्वेों के लिए। यदि आप अपना 'सदस्य प्रोफ़ाइल' पूर्ण और अद्यतित रखते हैं, तो आपको उन सर्वेों की अधिकतम संख्या प्राप्त होगी जिनके लिए आप अर्हता प्राप्त करते हैं"
    }, 
    {
        question : "मुझसे उम्र, आय और अन्य व्यक्तिगत जानकारी के बारे में प्रश्न क्यों पूछे जाते हैं?", 
        answer : "हम उचित मार्केट रिसर्च अध्ययन परियोजनाओं के साथ आपका बेहतर मिलान करने के लिए आपका नाम, पता, लिंग, जन्मदिन और रोजगार की स्थिति जैसी व्यक्तिगत जानकारी मांगते हैं। इस जानकारी का उपयोग प्रोत्साहन पूर्ति के लिए भी किया जाता है ताकि हम आपका इनाम उचित प्राप्तकर्ता पते पर भेज सकें। अन्य व्यक्तिगत जानकारी जो आपसे हमें प्रदान करने के लिए कहा जा सकता है, वह पूरी तरह से पैनलिस्टों के विश्वव्यापी मालिकाना डेटाबेस के निर्माण और संचालन के उद्देश्य से है, ताकि उस आधार पर मार्केट रिसर्च अध्ययन किया जा सके और हम अपने ग्राहकों को हमारे सर्वेों पर अज्ञात और समग्र रूप में आपकी प्रतिक्रियाएँ प्रदान कर सकें। अधिक जानने के लिए हमारी गोपनीयता नीति पढ़ें।"
    }, 
    {
        question : "सदस्य प्रोफाइल और सर्वे के बीच क्या अंतर है?", 
        answer : "सदस्य प्रोफ़ाइल हमें आपके बारे में कुछ बताती है और हमें उन सर्वेों के लिए आपको लक्षित करने की अनुमति देती है जो आपकी रुचियों या अनुभव से मेल खाते हैं। आप इन्हें 'मेरी प्रोफ़ाइल' में अपने खाली समय में पूरा कर सकते हैं। मार्केट रिसर्च सर्वे वे अध्ययन हैं जिनमें आपसे विशिष्ट उत्पादों, सेवाओं या विज्ञापनों पर अपनी राय देने के लिए कहा जाएगा। सर्वे केवल सीमित समय के लिए खुले होते हैं, जब तक कि प्रतिक्रिया कोटा पूरा नहीं हो जाता। कभी-कभी, किसी अध्ययन में बहुत विशिष्ट योग्यताएं होती हैं जो आबादी का केवल एक छोटा प्रतिशत ही पूरा कर सकता है। ऐसी स्थिति तब हो सकती है जब कोई दवा कंपनी एक दुर्लभ बीमारी से पीड़ित लोगों से प्रतिक्रिया का अनुरोध करती है। इस तरह के मामलों में, अध्ययन के लिए योग्यताओं को पूरा करने वाले मुट्ठी भर पैनलिस्टों को खोजने के लिए सर्वे स्क्रीनर्स का उपयोग करके पूरे पैनल से जाँच करना आवश्यक हो सकता है। अधिक i-प्वाइंट अर्जित करने के लिए कृपया अपनी प्रोफ़ाइल को अपडेट करना और उसे अपडेट रखना याद रखें।"
    }, 
    {
        question : "क्या कोई शामिल होने का शुल्क है?", 
        answer : "शामिल होने का कोई शुल्क नहीं है. सदस्यता निशुल्क है। इंडियापोल्स में पंजीकरण पूरी तरह से नि:शुल्क है - केवल हमारे सर्वेों का उत्तर देकर और विभिन्न अनुसंधान गतिविधियों में शामिल होकर, आप न केवल i-प्वाइंट अर्जित करेंगे जिन्हें वाउचर और नकद भुगतान के लिए बदला जा सकता है, बल्कि आपके मूल्यवान उत्तर ब्रांड को बाजार की जरूरतों को पहचानने में सक्षम बनाएंगे और अपने उत्पादों और सेवाओं में परिवर्तन कर के और इस प्रकार निकट भविष्य में सभी के लिए वस्तुओं और सेवाओं के समग्र सुधार में मदद करेगा।"
    }, 
    {
        question : "मैं इंडियापोल्स का सदस्य कैसे बनूँ?", 
        answer : 'इंडियापोल्स में शामिल होने के लिए, बस "पंजीकरण करें" पर क्लिक करें। अपना खाता बनाते समय आपसे कुछ बुनियादी जानकारी प्रदान करने के लिए कहा जाएगा। पंजीकरण करें करने के बाद, आपके पंजीकरण को अंतिम रूप देने के लिए आपको एक पुष्टिकरण ईमेल भेजा जाएगा। इंडियापोल्स पर अपने पंजीकरण की पुष्टि करने के लिए आपको इस ईमेल में दिए गए लिंक पर क्लिक करना होगा। एक बार आपका पंजीकरण पूरा हो जाने पर, आप सर्वेों में भाग लेना शुरू कर सकते हैं और i-प्वाइंट अर्जित करना शुरू कर सकते हैं और उन्हें हमारे विभिन्न विकल्पों के साथ भुना सकते हैं।'
    }, 
    {
        question : 'मैं अपने द्वारा अर्जित पुरस्कारों का उपयोग कैसे कर सकता हूं?', 
        answer : '<p>पुरस्कारों के लिए अपने i-प्वाइंट का भुनाने के लिए, कृपया नीचे दिए गए चरणों का पालन करें:</p> <ul><li>अपने अकाउंट में साइन इन करें</li> <li>"मेरे पुरस्कार" पृष्ठ पर जाएँ</li><li>विकल्प देखें और सुनिश्चित करें कि वो आपकी आवश्यकताओं को पूरा करते हैं।</li></ul>'
    }, 
    {
        question : 'एक बार ऑर्डर करने के बाद मेरा इनाम प्राप्त होने में कितना समय लगेगा?', 
        answer : 'i-प्वाइंट जमा करने का समय सर्वे पर निर्भर करता है। कुछ सर्वेों के लिए, i-प्वाइंट बहुत जल्दी या कुछ दिनों के भीतर जमा कर दिए जाते हैं, जबकि अन्य के लिए आपको i-प्वाइंट सर्वे बंद होने के बाद ही प्राप्त होंगे। सर्वे बंद होने के बाद से आपके खाते में i-प्वाइंट जमा होने के लिए आप अधिकतम छह सप्ताह तक इंतजार करने की उम्मीद कर सकते हैं, हालांकि हम इसे यथासंभव सीमित करने का प्रयास करते हैं।'
    }, 
    {
        question : 'मैं i-प्वाइंट कैसे अर्जित करूं? ', 
        answer : 'सबसे पहले, आपको i-प्वाइंट जमा करना शुरू करने के लिए एक सत्यापित ईमेल पते के साथ एक पंजीकृत इंडियापोल्स सदस्य होना चाहिए। एक बार जब आपका पंजीकरण पुर्ण हो जाता है, तो आप यहां इंडियापोल्स पर पाए गए सर्वेों को पूरा करके या ईमेल/व्हाट्सएप या एसएमएस के माध्यम से प्राप्त आमंत्रणों के माध्यम से i-प्वाइंट अर्जित कर सकते हैं। आप अपना प्रोफ़ाइल सर्वे भरकर और अपने दोस्तों को इंडियापोल्स में शामिल होने के लिए आमंत्रित करके अतिरिक्त i-प्वाइंट अर्जित कर सकते हैं।'
    }, 
    {
        question : 'क्या इसमें शामिल होने के लिए कोई उम्र की बाध्यता है?', 
        answer : 'खाता बनाने और सर्वे में भाग लेने के लिए आपकी आयु 16 वर्ष या उससे अधिक होनी चाहिए।'
    }, 
    {
        question : 'मैं अपनी व्यक्तिगत जानकारी कैसे अपडेट करूं?', 
        answer : 'अपने खाते में साइन इन करें और "प्रोफ़ाइल" पृष्ठ पर जाएँ। वहां से आप अपनी "व्यक्तिगत जानकारी" संपादित कर सकते हैं। आप उसी पृष्ठ से अन्य प्रोफ़ाइल जानकारी भी अपडेट कर सकते हैं और अधिक सर्वे प्राप्त करने का अधिक मौका प्राप्त कर सकते हैं।'
    }, 
    {
        question : 'मैं इंडियापोल्स के साथ अपनी सदस्यता कैसे समाप्त करूं?', 
        answer : 'अपने खाते में साइन इन करें और "मेरी सेटिंग्स" पर जाएंपृष्ठ के शीर्ष पर "इंडियापोल्स से सदस्यता समाप्त करें" बटन पर क्लिक करें.'
    }, 
    {
        question : 'आपके ग्राहक कौन हैं?', 
        answer : 'इंडियापोल्स हर दिन विभिन्न विषयों पर सर्वेों का उत्तर देने के लिए हजारों सदस्यों को आमंत्रित करता है। इन सर्वेों का उद्देश्य बड़े उपभोक्ता ब्रांड के उत्पादों और सेवाओं, एक उपभोक्ता के रूप में आपकी आदतों या आप जिस दुनिया में रहते हैं, उसके बारे में आपकी राय एकत्र करना है। आपकी राय का कंपनियों पर सीधा प्रभाव पड़ता हैं और वे कैसे विपणन, वितरण, आदि करेंगे। या उपभोक्ताओं के लिए नए उत्पादों और सेवाओं का विज्ञापन करें।'
    }, 
    {
        question : 'क्या मैं बंद सर्वेों में भाग ले सकता हूँ?', 
        answer : 'प्रत्येक सर्वे में कोटा निर्धारित होता है। जब कोई सर्वे उत्तरदाताओं की आवश्यक संख्या तक पहुंच जाता है, तो यह स्वचालित रूप से बंद हो जाएगा, और कोई और प्रतिक्रिया स्वीकार नहीं की जाएगी। यह सदस्यों की प्रतिक्रिया के आधार पर अनुमानित अंतिम तिथि से पहले भी हो सकता है, इसलिए i-प्वाइंट अर्जित करने का अवसर चूकने से बचने के लिए कृपया जितनी जल्दी हो सके शामिल हों।'
    }, 
    {
        question : 'मैंने एक सर्वे लेने की कोशिश की, लेकिन मैं योग्य नहीं हो सका ?', 
        answer : '<p>कभी-कभी सर्वे ऐसे उत्तरदाताओं की मांग करता है जो बहुत विशिष्ट मानदंडों को पूरा करते हों। ऐसा इसलिए है क्योंकि हमारे ग्राहकों को किसी विशिष्ट आयु वर्ग या किसी विशेष प्रकार के उत्पाद का उपयोग करने वाले लोगों से फीडबैक की आवश्यकता हो सकती है।</p><p>भविष्य के ऑनलाइन सर्वेों के लिए निमंत्रण प्राप्त करने की अपनी संभावनाओं को बढ़ाने के लिए, अधिक i-प्वाइंट अर्जित करने के लिए अपने सभी सदस्य प्रोफाइल को पूरा करें।</p>'
    }, 
    {
        question : 'जब मुझे कुछ ही समय पहले निमंत्रण मिला तो सर्वे पूरा क्यों है ?', 
        answer : '<p>कभी-कभी ऐसा होता है यदि कोई सर्वे अपेक्षा से अधिक प्रतिक्रियाएँ उत्पन्न कर रहा हो। साथ ही, जरूरी नहीं कि निमंत्रण आपके ईमेल सेवा प्रदाता द्वारा तुरंत वितरित किए जाएं।</p><p>इसलिए, हम अपने सभी सदस्यों को सलाह देते हैं कि वे ईमेल के साथ-साथ अपना व्हाट्सएप या एसएमएस भी चेक करते रहें, ताकि वे i-प्वाइंट अर्जित करने का कोई भी मौका न चूकें।</p><p>आपको होने वाली किसी भी असुविधा के लिए हम क्षमा चाहते हैं और आपकी भागीदारी के लिए धन्यवाद देते हैं।</p><p>कृपया जान लें कि जल्द ही कुछ समय में आपके लिए अधिक सर्वे अवसर उपलब्ध होंगे।</p>'
    }, 
    {
        question : 'प्रत्येक सर्वे की समय अवधि क्या है?', 
        answer : 'सर्वे की अवधि पूरी तरह से अध्ययन पर निर्भर करती है लेकिन एक सामान्य सर्वे की अवधि 20 मिनट से 40 मिनट के बीच होती है।'
    }, 
    {
        question : 'मुझे काफी समय से कोई सर्वे नहीं मिला है. मुझे कितनी प्रतीक्षा करनी होगी?', 
        answer : '<p>आपके खाते में, कोई भी उपलब्ध सर्वे "मेरे सर्वे" टैब में दिखाया जाएगा।</p><p>सदस्यों को प्रत्येक सर्वे की विशिष्ट आवश्यकता और आवश्यकताओं के अनुसार सर्वे में भाग लेने के लिए आमंत्रित किया जाता है। उपयुक्त सर्वे शुरू होते ही निमंत्रण स्वचालित रूप से भेजे जाएंगे।</p> <p>आपके द्वारा दर्ज की गई प्रोफ़ाइल जानकारी यह सुनिश्चित करने के लिए बहुत महत्वपूर्ण है कि आपका यथासंभव अधिक से अधिक सर्वेों से मिलान किया जा सके। यदि आप अपना "सदस्य प्रोफ़ाइल" पूर्ण और अद्यतन रखते हैं, तो आपको उन सर्वेों की अधिकतम संख्या प्राप्त होगी जिनके लिए आप योग्य हैं।</p> <p>अपने मोबाइल ऐप पर सर्वे आमंत्रणों की समय पर सूचनाएं प्राप्त करने के लिए कृपया अपने ब्राउज़र का "cache" और "cookies" साफ़ करें।</p> <p><a href="https://play.google.com/store/apps/details?id=com.dataxing.indiapolls" target="_blank">Android</a> या <a href="https://apps.apple.com/in/app/indiapolls/id6477344310" target="_blank">iOS</a> मोबाइल ऐप डाउनलोड करें।</p>'
    }, 
    {
        question : ' मैं सर्वे कैसे करूँ?', 
        answer : '<p>आपके साइन इन करने के बाद सभी उपलब्ध सर्वे आपके सर्वे पृष्ठ पर सूचीबद्ध होंगे। इस पृष्ठ से, आप वैध प्रतिक्रिया और सर्वे समयरेखा की समाप्ति के लिए पात्र i-प्वाइंट की अधिकतम संख्या देख सकते हैं।</p><p>आपको एक ईमेल या एसएमएस प्राप्त होगा, जिसमें आपको आमंत्रित किए गए प्रत्येक नए सर्वे के बारे में सूचित किया जाएगा। यदि आपने हमारा मोबाइल ऐप इंस्टॉल किया है, तो आपको ईमेल के बजाय ऐप के माध्यम से या इसके अतिरिक्त एक अधिसूचना भी प्राप्त हो सकती है।</p>'
    }, 
    {
        question : 'पंजीकरण करते समय मेरे द्वारा दी गई प्रोफ़ाइल जानकारी का क्या किया जाता है?', 
        answer : 'आपका प्रतिक्रिया डेटा हमारे सुरक्षित सर्वर पर संग्रहीत है जो केवल पैनल को उन पैनलिस्टों को कॉल करने की अनुमति देता है, जो सर्वे में भाग लेने के लिए विशिष्ट मानदंडों से मेल खाते हैं। यह जाँच पूरी तरह से स्वचालित है, और हमारे सुरक्षित सर्वेों में भाग लेने के लिए पैनल द्वारा पैनलिस्टों से ईमेल के माध्यम से संपर्क किया जाता है। सभी प्रतिक्रियाओं को समग्र रूप से रखा जाता है। जिसका अर्थ है कि व्यक्तिगत प्रतिक्रियाएं व्यक्तिगत रूप से पहचान योग्य जानकारी से जुड़ी नहीं हैं। आपके द्वारा प्रदान की गई जानकारी का उपयोग कभी भी विज्ञापन या बिक्री उद्देश्यों के लिए नहीं किया जाएगा। आप किसी भी समय किसी भी उत्पाद या सेवा को खरीदने के लिए ज़िम्मेदार नहीं हैं, न ही पैनल में शामिल होने के परिणामस्वरूप कोई कंपनी आपसे अनुरोध करेगी।'
    }, 
    {
        question : 'जो इनाम मैं जीतूंगा उसे मुझे कहां भेजोगे?', 
        answer : 'पुरस्कार केवल उसी पते पर भेजा जाएगा जो आपने अपने पंजीकरण फॉर्म में दिया है। जैसे ही आप आगे बढ़ें, "खाता सेटिंग" में अपना पता अपडेट करें। साथ ही, कृपया सुनिश्चित करें कि आपका पता सटीक है ताकि आपके वाउचर/पुरस्कार सही पते पर भेजे जा सकें।'
    }, 
    {
        question : 'आप कैसे जानेंगे कि मेरी प्रतिक्रियाएँ सटीक हैं?', 
        answer : 'हम प्रतिक्रियाओं की सटीकता की जांच करने के लिए सर्वे के भीतर चेक/बैलेंस/एल्गोरिदम का निर्माण करते हैं। हम यह भी देखते हैं कि प्रतिवादी को जवाब भरने में कितना समय लगता है ताकि यह पता चल सके कि आपका जवाब वास्तविक है या नहीं।'
    }, 
    {
        question : 'यदि मैं ग्राहक हूं तो मुझे इंडियापोल्स में क्यों शामिल होना चाहिए?', 
        answer : '<p>आप एक ग्राहक हैं और आपकी एक राय है. आपकी राय मायने रखती है। और जब भी आप इसे व्यक्त करते हैं तो हम आपको अपनी बहुमूल्य राय देने का अवसर देते हैं। उत्पादों या सेवाओं के बारे में आपकी बहुमूल्य राय और सुझाव आपके इच्छित और आवश्यक उत्पादों और सेवाओं को आकार देने में बहुत मददगार होंगे।</p><p>इसके अलावा, अपनी बहुमूल्य राय देने के अलावा, आप i-प्वाइंट भी अर्जित करते हैं जिसे हमारे सदस्यों के लिए हमारे पास मौजूद विभिन्न इनाम विकल्पों के रूप में भुनाया जा सकता है।</p>'
    }, 
    {
        question : 'इंडियापोल्स i-प्वाइंट क्या हैं?', 
        answer : '<p>i-प्वाइंट एक प्रकार की आभासी मुद्रा है जो इंडियापोल्स के सदस्यों को विभिन्न कार्यों जैसे : सर्वे में भागीदारी, पंजीकरण प्रक्रिया पूरी करने वाले दोस्तों को इंडियापोल्स में शामिल होने के लिए आमंत्रित करना, प्रोफ़ाइल सर्वे पूरा करना, के लिए प्रदान की जाती है।</p><p>जब आप इंडियापोल्स पर पंजीकरण करें करते हैं तो आपको साइट पर आपका स्वागत करने के लिए कुछ i-प्वाइंट प्राप्त होंगे। जब आपने पर्याप्त i-प्वाइंट अर्जित कर लिए हैं, तो आप उन्हें पुरस्कारों के लिए भुना सकते हैं, जैसे कि बड़ी दुकानों और ब्रांड के वाउचर या यूपीआई भुगतान या कैशबैक।</p><p>हमारे सभी ऑफ़र से अपडेट रहने के लिए, कृपया पुरस्कार केंद्र पर जाएँ।.</p>'
    }, 
    {
        question : 'मैं मोबाइल पर सर्वेों में कैसे भाग ले सकता हूँ ?', 
        answer : '<p>यदि आप अपने स्मार्टफोन पर सर्वे प्राप्त करना चाहते हैं, तो बस अपने पंजीकरण के दौरान या सीधे अपने खाता पृष्ठ पर इंडियापोल्स पर अपना मोबाइल फोन नंबर दर्ज करें। इंडियापोल्स केवल उन विशिष्ट उपयोगकर्ताओं को मोबाइल पर सीमित संख्या में सर्वे भेजेगा जिनके बारे में हमारा मानना है कि वे योग्य होंगे। आपको पाठ संदेश द्वारा सर्वे का उत्तर देने की आवश्यकता नहीं होगी। आपको प्राप्त होने वाले एसएमएस/व्हाट्सएप में सर्वे का एक लिंक शामिल होगा। जब आप अपने स्मार्टफ़ोन से किसी सर्वे तक पहुँचते हैं, तो कृपया सुनिश्चित करें कि आपके पास एक अच्छा इंटरनेट कनेक्शन है। हम आपके मासिक बिल/टॉप-अप पर अतिरिक्त लागत से बचने के लिए, आपके मोबाइल इंटरनेट प्लान/मोबाइल डेटा के माध्यम से सर्वे लेने के बजाय वाई-फाई सुरक्षित कनेक्शन का उपयोग करने की सलाह देते हैं।</p><p>चेतावनी: आपके मोबाइल सेवा प्रदाता के आधार पर मानक एसएमएस दरें लागू हो सकती हैं।</p>'
    }, 
    {
        question : 'जो मोबाइल पर सर्वे में भाग ले सकते हैं?', 
        answer : '<p>कोई भी व्यक्ति जो इंडियापोल्स का सदस्य है और उसने www.IndiaPolls.com साइट पर अपना मोबाइल फोन नंबर दर्शाया है, वह मोबाइल पर सर्वे में भाग ले सकता है।</p>'
    }, 
    {
        question : 'क्या सर्वे केवल एसएमएस/व्हाट्सएप के माध्यम से भेजे जाते हैं?', 
        answer : 'विशिष्ट परियोजनाओं के लिए कुछ सर्वे एसएमएस/व्हाट्सएप के माध्यम से भेजे जा सकते हैं। अधिकांश सर्वेों के लिए आप ईमेल आमंत्रण और हमारे मोबाइल ऐप के माध्यम से भाग ले सकते हैं।'
    }, 
    {
        question : 'मैं कितने i-प्वाइंट अर्जित कर सकता हूं?', 
        answer : 'इंडियापोल्स पर आप कितने i-प्वाइंट जमा कर सकते हैं इसकी कोई सीमा नहीं है क्योंकि इंडियापोल्स से आप अपनी दुनिया को कितना प्रभावित कर सकते हैं इसकी भी कोई सीमा नहीं है!'
    }, 
    {
        question : 'क्या i-प्वाइंट का उपयोग एक निश्चित समय सीमा के भीतर करना होगा?', 
        answer : '<p>हाँ। जब i-प्वाइंट आपके खाते में जमा हो जाएंगे, तो वे 12 महीने के लिए वैध रहेंगे। यदि इस अवधि के बाद i-प्वाइंट का उपयोग नहीं किया गया है, तो वे स्वचालित रूप से समाप्त हो जाएंगे और आपके खाते से हटा दिए जाएंगे।</p><p>आपके i-प्वाइंट एक बार में समाप्त नहीं होंगे । इसके बजाय, i-प्वाइंट आपके मूल रूप से अर्जित करने के 12 महीने बाद समाप्त हो जाएंगे (उदाहरण के लिए: यदि आपने 15 फरवरी 2024 को i-प्वाइंट अर्जित किए हैं, तो वे 28 फरवरी 2025 को आपके खाते से हटा दिए जाएंगे)। यह कटौती हमेशा उस महीने के अंत में होगी जिसमें उन्हें अर्जित किया गया था। कृपया अपने i-प्वाइंट भुनाने के लिए अंतिम क्षण तक प्रतीक्षा न करें।</p>'
    }, 
    {
        question : 'क्या इंडियापोल्स के पास कोई मोबाइल ऐप है?', 
        answer : '<p>हां, इंडियापोल्स मोबाइल ऐप <p><a href="https://play.google.com/store/apps/details?id=com.dataxing.indiapolls" target="_blank">Android</a> और <a href="https://apps.apple.com/in/app/indiapolls/id6477344310" target="_blank">iOS</a> दोनों उपयोगकर्ताओं के लिए उपलब्ध है:</p><p>iOS के लिए इंडियापोल्स ऐप डाउनलोड करें।</p><p>Android के लिए इंडियापोल्स ऐप डाउनलोड करें।</p>'
    }, 
    {
        question : 'मैं दोस्तों को इंडियापोल्स में शामिल होने के लिए कैसे आमंत्रित कर सकता हूं?', 
        answer : '<p>अपने दोस्तों को इंडियापोल्स में आमंत्रित करने के लिए, आप अपने व्यक्तिगत रेफरल लिंक को कॉपी करके अपनी पसंद के किसी भी प्लेटफॉर्म पर साझा कर सकते हैं। "किसी मित्र को आमंत्रित करें" लिंक आपके खाता पृष्ठ में "किसी मित्र को रेफर करें" टैब में पाया जा सकता है।</p>'
    }, 
    {
        question : 'किसी मित्र को आमंत्रित करने पर मैं कितने i-प्वाइंट अर्जित करूंगा?', 
        answer : 'हर बार जब आप किसी मित्र को आमंत्रित करते हैं, तो आपके मित्र द्वारा इंडियापोल्स समुदाय में शामिल होने के लिए अपना पंजीकरण पूरा करने के बाद आपके खाते में 25 i-प्वाइंट जमा कर दिए जाएंगे। यह सुनिश्चित करने के बाद कि सभी नए मित्र वास्तविक लोग हैं, कृपया ध्यान दें कि आप प्रति माह अधिकतम 10 नए मित्रों के लिए ही i-प्वाइंट अर्जित कर सकते हैं।'
    }, 
    {
        question : 'पुरस्कारों के बदले कितने i-प्वाइंट की आवश्यकता है?', 
        answer : '<p>ध्यान दें कि 100 i-प्वाइंट का मूल्य 100 रुपये है। इससे पहले कि आप उन्हें अपनी पसंद के इनाम के लिए एक्सचेंज कर सकें, आपको न्यूनतम राशि अर्जित करनी होगी।</p><p>उपलब्ध इनाम विकल्पों और आवश्यक न्यूनतम i-प्वाइंट देखने के लिए यहां क्लिक करें।</p>'
    }, 
    {
        question : 'मैंने मोचन अनुरोध किया लेकिन मुझे अपना इनाम नहीं मिला। मुझे अपना ई-गिफ्ट कार्ड कब मिलेगा?', 
        answer : '<p>आपको नीचे दिए गए समय-सीमा के आधार पर अपना ई-गिफ्ट कार्ड प्राप्त होगा।</p><p>· आजीओ ई-गिफ्ट कार्ड - 7 कार्य दिवसों के भीतर</p><p>· फ्लिपकार्ट INR ई-गिफ्ट कार्ड - 7 कार्य दिवसों के भीतर</p><p>· गूगल प्ले ई-गिफ्ट कार्ड - 7 कार्य दिवसों के भीतर</p><p>· क्रोमा ई-गिफ्ट कार्ड - 15 कार्य दिवसों के भीतर</p><p>· फ़ोन-पे ई-गिफ्ट कार्ड - 15 कार्य दिवसों के भीतर</p><p>· अमेज़ॅन ई-गिफ्ट कार्ड - 15 - 30 कार्य दिवसों के भीतर</p>'
    }, 
    {
        question : 'मेरा फ्लिपकार्ट वाउचर कोड काम नहीं कर रहा है। मुझे क्या करना चाहिए?', 
        answer : '<p>अपना फ्लिपकार्ट उपहार कार्ड भुनाने के लिए यहां <a href="/#/redemption" target="_blank">क्लिक करें</a>।</p><p>फ्लिपकार्ट ग्राहक सेवा: 18002089898</p><p>वे आपके प्रश्नों के समाधान के लिए दिन के 24 घंटे, सप्ताह के 7 दिन उपलब्ध हैं।</p><p>ज्यादा जानकारी के लिए यहां क्लिक करें।</p>'
    }, 
    {
        question : 'मेरा अमेज़ॅन वाउचर कोड काम नहीं कर रहा है। मुझे क्या करना चाहिए?', 
        answer : '<p>अपना अमेज़न गिफ्ट कार्ड भुनाने के लिए यहां <a href="/#/redemption" target="_blank"> क्लिक करें। </a></p><p>अमेज़न ग्राहक सेवा: 180030002049</p><p>वे आपके प्रश्नों के समाधान के लिए दिन के 24 घंटे, सप्ताह के 7 दिन उपलब्ध हैं।</p><p>अमेज़न ग्राहक सेवा से संपर्क करने के लिए <a href="https://www.amazon.in/gp/help/customer/display.html" target="_blank">यहां क्लिक </a>करें। </p>'
    }
];


function FaqHi() {

const { userId, role } = useSelector((state : any) => state.adminUser.adminUser);
const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
    },
    appBar: {
        marginBottom: theme.spacing(3),
    },
    content: {
        padding: theme.spacing(3),
        textAlign: 'left',
    },
    paper: {
        padding: theme.spacing(2),
        display: 'flex',
        overflow: 'auto',
        flexDirection: 'column',
        alignItems: 'center',
    },
    logo: {
        width: '100%',
        maxWidth: '400px', // Adjust the maximum width as needed
    },
    grow: {
        flexGrow: 1,
    },
}));

const MODAL_TYPES = {
    NONE: 'NONE',
    CREATE: 'CREATE',
    UPDATE: 'UPDATE',
    DELETE: 'DELETE',
    DETAILS: 'DETAILS',
    QUESTION: 'QUESTION'
  };

const [formType, setFormType] = useState(MODAL_TYPES.NONE);
const [status, setStatus] = useState(PageStatus.None);
const [error, setError] = useState(null);
const [formState, setFormState] = useState({});
const [faqApiData, setFaqApiData] = useState([]);
const [pageSize, setpageSize] = useState(10);
const [currentPageNumber, setCurrentPageNumber] = useState(1);
const [totalResponseData, setTotalResponseData] = useState('');
const [totalResponsePages, setTotalResponsePages] = useState('');
const [modalHeader, setModalHeader] = useState("जोड़ें");
const [answerBody, setAnswerBody] = useState("");
const [errorBody, setErrorBody] = useState('');
const [id, setId] = useState('');

const handleOpenCreateModal = () => { setFormType(MODAL_TYPES.CREATE); setModalHeader("जोड़ें"); setId('');};

const fetchList = async () => {
  setStatus(PageStatus.Loading);
  try {
    const responseData : any = await FaqAPI.getAll(pageSize, currentPageNumber, 'hi');
    setFaqApiData(responseData.data);
    setTotalResponseData(responseData.totalCount);
    setTotalResponsePages(responseData.totalPage);
    
    setStatus(PageStatus.Loaded);
  } catch (err) {
    setError("असफल, पुनः प्रयास करें!");
    setStatus(PageStatus.Error);
  }
};

const onCloseModalFunc = () => { setFormType(MODAL_TYPES.NONE); setFormState({}); setAnswerBody('')};

const onFormSubmit = async (event)=>{
  event.preventDefault();
  if (!answerBody.trim()) {  setErrorBody('यह फ़ील्ड अनिवार्य है|');  return;  }
  let answer = JSON.stringify(answerBody);
  try {
    let submitingData = {...formState, answer, language : "hi"};    
    let apiRespo : any;
    if (id) {
      apiRespo = await FaqAPI.updatedetails(id, submitingData);
    }else{
      apiRespo = await FaqAPI.create(submitingData);
    }
    setStatus(PageStatus.Submitting);
    const responseData : any = apiRespo;
    setStatus(PageStatus.Submitted);
    setFormType(MODAL_TYPES.NONE);
    setFormState({});
    setAnswerBody("");
    fetchList();
  } catch (err) {
    setError("असफल, पुनः प्रयास करें!");
    setErrorBody('');
    setStatus(PageStatus.Error);
  }
}

const handleChange = (e) => {
  let {name, value} = e.target;
  setFormState((prev)=>({
      ...prev, [name] : value
  }));
};

const setAnswerBodyFunc = (value)=>{ setAnswerBody(value); }

const updateFaqData = (e, elem)=>{
  e.stopPropagation();
  setId(elem.id);
  setFormType(MODAL_TYPES.CREATE);
  setModalHeader("अपडेट करें");
  setFormState({"question": elem.question});
  setAnswerBody(JSON.parse(elem.answer));
}

useEffect(() => {  fetchList(); }, [pageSize, currentPageNumber]);

const handlePageSizeChange = (newValue : any) => { setpageSize(newValue); setCurrentPageNumber(1); setTotalResponsePages(''); };
const handlePageNumberChange = (newValue : any) => { setCurrentPageNumber(newValue); };

    const classes = useStyles();
    return (
        <>
        <Modal
            centered
            size="lg"
            backdrop="static"
            onHide={onCloseModalFunc}
            show = {formType == MODAL_TYPES.CREATE}
            style={{ zIndex: 1201 }}
          >
            <Modal.Header closeButton>
              <Modal.Title> अक्सर पूछे जाने वाले प्रश्न {modalHeader} </Modal.Title>
            </Modal.Header>
            <Modal.Body style={{ maxHeight: '78vh', overflow: 'auto' }}>
              <Show when={status === PageStatus.Loading}>
                <div className="d-flex justify-content-center w-100 p-5">
                  <Spinner animation="border" variant="primary" />
                </div>
              </Show>
              {/* <Alert variant="danger" show={status === PageStatus.Error}>  {error}  </Alert> */}
                      <form  onSubmit={onFormSubmit} >
                        <div className="row mt-2">
                            <div className="col">
                            <label htmlFor="titleEng">  प्रश्न*  </label>
                            <input
                                className="form-control"
                                name = "question"
                                onChange={handleChange}
                                value={formState.question || ""}
                                placeholder="प्रश्न लिखें"
                                required
                            />
                            </div>
                        </div>

                        <div className="row mt-2">
                            <div className="col">
                                <label htmlFor="body">उत्तर*</label>
                                <ReactQuill
                                    theme="snow" // other themes: 'bubble', 'core'
                                    onChange={setAnswerBodyFunc}
                                    name="answer"
                                    value={answerBody || ""}
                                    required
                                />
                                {errorBody && <div style={{ color: 'red' }}>{errorBody}</div>}
                            </div>
                        </div>

                        <Alert variant="danger" show={error} className="mt-2">
                            {error}
                        </Alert>

                        <div className="d-flex align-items-center mt-2">
                            <button
                                type="submit"
                                // disabled={!this.state.body || !this.state.subject}
                                className="btn btn-primary mr-3"
                            >
                                जमा करें
                            </button>

                            <Show when={status === PageStatus.Submitting}>
                                <Spinner animation="border" variant="primary" />
                            </Show>
                        </div>
                    </form>
            </Modal.Body>
          </Modal>

        <div className={classes.root}>
        <AppBar position="static" className={classes.appBar}>
            <Toolbar>
                <Typography variant="h6">अक्सर पूछे जाने वाले प्रश्न</Typography>
                <div className={classes.grow} />
                { (role  && (role == "admin" || role == "sub-admin") ? <Typography variant="h6">
                <Button
                    onClick={handleOpenCreateModal}
                      variant="primary"
                      size="sm"
                      className="mx-1"
                  >
                    <FontAwesomeIcon icon={['fas', 'plus']} className="mr-2" />
                    नया बनाएं
                  </Button>
                </Typography> : "")}
            </Toolbar>
        </AppBar>
        <Container maxWidth="lg" className={classes.content}>
            <Paper className={classes.paper}>
                <img alt="Logo" src={Assets.Logo2} className={classes.logo} />
                <Typography variant="h4" gutterBottom>
                अक्सर पूछे जाने वाले प्रश्न
                </Typography>
            </Paper>
            <div className='mb-2 mt-3'>  
              <ShowDataAccording2PageSize 
                currentPageSize={pageSize} 
                currentPage={currentPageNumber}
                sendPageSize={handlePageSizeChange}
                showTotalData={totalResponseData} 
                sendLastPage={totalResponsePages}
              />
            </div>
            <div>
        {faqApiData.map((faq, index) => (
          <Accordion key={index}>
            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                <Typography>{faq.question} &nbsp; 
                    {role && (role == "admin" || role == "sub-admin") ? (
                    <i
                        className='fa fa-edit text-success'
                        onClick={(event) => updateFaqData(event, faq)}
                        title="Edit details"
                    ></i>
                    ) : null}
                </Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Typography>
              <div dangerouslySetInnerHTML={{ __html: JSON.parse(faq.answer) }} />
              </Typography>
            </AccordionDetails>
          </Accordion>
        ))}
      </div>
        <div>
            {totalResponsePages && <PaginationNumbering 
            currentPage={currentPageNumber} 
            returnPagenumber={handlePageNumberChange}
            showTotalData={totalResponseData} 
            sendLastPage={totalResponsePages}
            />}
        </div>
        </Container>
    </div>
        </>

    );
  }

  export default FaqHi;
